import brandLogo from "../logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import uiStyles from "../theme/uiStyles";

export default function Navbar() {
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const routerLocation = useLocation();
  const path = routerLocation.pathname;
  const isResult = path === "/home/result";
  const hideNavbar = path === "/" || path === "/login" || path === "/register";
  if (hideNavbar) return null;

  return (
    <div style={uiStyles.navbar}>
      <div style={styles.brand} onClick={() => nav("/")}>
        <img src={brandLogo} alt="NextBite logo" style={styles.logoMark} />
        <span style={styles.brandName}>NextBite</span>
      </div>

      <div style={styles.right}>
        {isResult && (
          <button onClick={() => nav("/home")} style={styles.simpleBtn}>
            ← Back
          </button>
        )}
        {user ? (
          <>
            <button onClick={() => nav("/home")} style={styles.loginBtn}>
              Discover
            </button>
            <button onClick={() => nav("/history")} style={styles.loginBtn}>
              History
            </button>
            <button onClick={() => nav("/profile")} style={styles.loginBtn}>
              Profile
            </button>
            <button onClick={logout} style={styles.logout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <button onClick={() => nav("/login")} style={styles.loginBtn}>
              Login
            </button>
            <button onClick={() => nav("/register")} style={styles.registerBtn}>
              Sign up
            </button>
          </>
        )}
      </div>
    </div>
  );
}

/* Styles */
const styles = {
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 20px",
    borderBottom: "1px solid #eee",
    background: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 100
  },
  brand: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    flexShrink: 0
  },
  links: {
    display: "flex",
    gap: 10
  },
  img: {
  width: 40,
  height: 40,
  objectFit: "contain",
  borderRadius: 8
  },
  logo: {
  width: 36,
  height: 36,
  objectFit: "contain",
  cursor: "pointer"
  },
  logoMark: {
    width: 32,
    height: 32,
    objectFit: "contain",
  },
  brandName: {
    fontWeight: 700,
    fontSize: 17,
    color: "#1a1a1a",
    letterSpacing: 0.2,
    marginLeft: 8,
  },
  simpleBtn: {
    padding: "8px 16px",
    borderRadius: 999,
    border: "1px solid #e2e8f0",
    background: "#fff",
    color: "#475569",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    transition: "all 0.2s ease"
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexShrink: 0
  },
  loginBtn: {
    padding: "8px 16px",
    borderRadius: 999,
    border: "1px solid #e2e8f0",
    background: "transparent",
    color: "#475569",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  registerBtn: {
    padding: "8px 18px",
    borderRadius: 999,
    border: "none",
    background: "linear-gradient(135deg, #ff7a59, #f25f4c)",
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 4px 14px rgba(242,95,76,0.28)",
    transition: "all 0.2s ease"
  },
  logout: {
    padding: "8px 18px",
    borderRadius: 999,
    border: "1px solid #e2e8f0",
    background: "transparent",
    color: "#475569",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease"
  }
};
